<template>
  <div v-if="notices.length" class="sub-agent-notice-bar">
    <div class="notice-icon-wrap">
      <img class="notice-icon" src="@/assets/packageAssets/views/P2_Page/Invite/default/notice.webp" alt="" />
    </div>
    <div class="notice-content">
      <div ref="noticeContent" class="notice-viewport">
        <transition :name="noticeTransitionName">
          <div :key="noticeIndex" class="notice-item">
            <span class="notice-text">
              <em class="notice-time">
                <MyPLabel :str="$t(currentNotice.timeLabel.langKey)" :numsOption="currentNotice.timeLabel.numsOption" />
              </em>
              ·
              <MyPLabel :str="$t(currentNotice.messageLangKey)" :numsOption="currentNotice.messageNumsOption" />
            </span>
          </div>
        </transition>
      </div>
      <div class="mask1"></div>
      <div class="mask2"></div>
    </div>
  </div>
</template>

<script>
import noticeScrollMixin from '../hooks/notice-scroll.mixin.js'

export default {
  name: 'SubAgentNoticeBar',
  mixins: [noticeScrollMixin],
  props: {
    notices: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss" scoped>
.sub-agent-notice-bar {
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  background: linear-gradient(90deg, #fffeeb 0%, #ffebee 100%);
  border-radius: 8px;
  overflow: hidden;

  .notice-icon-wrap {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px 8px;
    background: linear-gradient(138.77deg, #fff3eb 0.56%, #ffebf5 101.31%);

    .notice-icon {
      width: 20px;
      height: 20px;
    }
  }

  .notice-content {
    flex: 1;
    min-width: 0;
    padding: 6px 8px 6px 4px;
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;

    .notice-viewport {
      flex: 1;
      min-width: 0;
      height: var(--lh-title-20);
      overflow: hidden;
      position: relative;
    }

    .notice-item {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 100%;
    }

    .mask1 {
      position: absolute;
      inset-inline-start: 0;
      top: 0;
      width: 8px;
      height: 100%;
      background: linear-gradient(270deg, rgba(254, 249, 222, 0) 0%, #fffceb 100%);
      pointer-events: none;
      z-index: 1;
    }

    .mask2 {
      position: absolute;
      inset-inline-end: 0;
      top: 0;
      width: 8px;
      height: 100%;
      background: linear-gradient(270deg, #ffebee 0%, rgba(255, 235, 238, 0) 100%);
      pointer-events: none;
      z-index: 1;
    }

    .notice-text {
      position: absolute;
      top: 0;
      inset-inline-start: 0;
      white-space: nowrap;
      font-family: var(--string-font);
      font-size: var(--fs-14);
      line-height: var(--lh-title-20);
      color: rgba(0, 0, 0, 0.6);

      :deep(.custom-p-label) {
        display: inline;
        margin: 0;
      }

      .notice-time {
        font-style: italic;
        font-weight: var(--fw-700);
      }
    }
  }
}
</style>

<style lang="scss">
.sub-agent-notice-bar {
  .notice-vertical-enter-active,
  .notice-vertical-leave-active,
  .notice-vertical-rtl-enter-active,
  .notice-vertical-rtl-leave-active {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    transition: transform 0.35s ease;
  }

  .notice-vertical-leave-active,
  .notice-vertical-rtl-leave-active {
    z-index: 1;
  }

  .notice-vertical-enter-active,
  .notice-vertical-rtl-enter-active {
    z-index: 2;
  }

  .notice-vertical-enter {
    transform: translateY(100%);
  }

  .notice-vertical-leave-to {
    transform: translateY(-100%);
  }

  .notice-vertical-rtl-enter {
    transform: translateY(-100%);
  }

  .notice-vertical-rtl-leave-to {
    transform: translateY(100%);
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .sub-agent-notice-bar {
    background: linear-gradient(270deg, #fffeeb 0%, #ffebee 100%);

    .notice-content {
      .mask1 {
        background: linear-gradient(90deg, rgba(254, 249, 222, 0) 0%, #fffceb 100%);
      }

      .mask2 {
        background: linear-gradient(90deg, #ffebee 0%, rgba(255, 235, 238, 0) 100%);
      }
    }
  }
}
</style>
